import React, { useState } from 'react'
import MoneyCard from './MoneyCard'
import SuccessPage from './SuccessPage'
import {Link} from 'react-router-dom'
function Payment() {
    const [method1, setmethod1] = useState(false)
    const [method2, setmethod2] = useState(true)
    const [method3, setmethod3] = useState(false)
    const [method4, setmethod4] = useState(false)
    const [processingFee, setprocessingFee] = useState(58)
    const [success, setSuccess] = useState(false)
    let handleMethod = (num) => {
        switch (num) {
            case 1:
                setmethod1(true)
                setmethod2(false)
                setmethod3(false)
                setmethod4(false)
                setprocessingFee(0)
                break;
                case 2:
                    setmethod1(false)
                    setmethod2(true)
                    setmethod3(false)
                    setmethod4(false)
                    setprocessingFee(58)
                    break;
            case 3:
                setmethod1(false)
                setmethod2(false)
                setmethod3(true)
                setmethod4(false)
                setprocessingFee(85)
                break;
                case 4:
                    setmethod1(false)
                    setmethod2(false)
                    setmethod3(false)
                    setmethod4(true)
                    setprocessingFee(40)
                    break;
                    
                }


    }

    return (
        <div>
        {success ? <SuccessPage/>:
            <div className="row justify-content-center w-100 white-2" style={{ marginTop: "14%" }}>
                <div className="col-md-5 mr-2 ">
                    <div className="p-3 d-flex  shadow-lg justify-content-evenly align-items-center rounded border border-info">
                        <h4 className="white-2">Promo Code</h4>
                        <input type="text " className='rounded px-2 ' name="" id="" style={{ background: "grey", border: "none", outline: "none", height: "30px" }} />
                        <a href="" className="btn btn-primary teal darken-1 letter-dis-1 ">Redeem</a>
                    </div>
                    <div className="my-4 p-3 rounded shadow-lg" style={{ background: "#1A1A40" }}>
                        <h5 className="white-3">Payment Method</h5>
                        <div className="d-flex flex-column">
                            <div className={`p-2 mb-2   border border-${method1 ? "info" : "primary"} rounded d-flex justify-content-between align-items-center`} onClick={() => handleMethod(1)} style={{ cursor: 'pointer' }}>
                                <label className="h5" ><ion-icon name="card-outline" style={{ color: "white", marginRight: "5px", fontSize: "20px" }}></ion-icon>Debit / Credit card</label>
                                <input type="radio" className="radioColorGreen" checked={method1} name="payment" id="dabit" />
                            </div>
                            {method1 && <MoneyCard />}

                            <div className={`p-2 mb-2   border border-${method2 ? "info" : "primary"} rounded d-flex justify-content-between align-items-center`} onClick={() => handleMethod(2)} style={{ cursor: 'pointer' }}>
                                <label className="h5" ><ion-icon name="logo-paypal" style={{ color: "white", marginRight: "5px", fontSize: "20px" }}></ion-icon>Paypal</label>
                                <input type="radio" className="radioColorGreen" checked={method2} name="payment" id="paypal" />
                            </div>
                            <div className={`p-2 mb-2   border border-${method3 ? "info" : "primary"} rounded d-flex justify-content-between align-items-center`} onClick={() => handleMethod(3)} style={{ cursor: 'pointer' }}>
                                <label className="h5" ><ion-icon name="wallet-outline" style={{ color: "white", marginRight: "5px", fontSize: "20px" }}></ion-icon>Skrill eWallet</label>
                                <input type="radio" className="radioColorGreen" checked={method3} name="payment" id="skrill" />
                            </div>
                            <div className={`p-2 mb-2   border border-${method4 ? "info" : "primary"} rounded d-flex justify-content-between align-items-center`} onClick={() => handleMethod(4)} style={{ cursor: 'pointer' }}>
                                <label className="h5" ><ion-icon name="card-outline" style={{ color: "white", marginRight: "5px", fontSize: "20px" }}></ion-icon>Bank Transfer</label>
                                <input type="radio" className="radioColorGreen" checked={method4} name="payment" id="bankTransfer" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 p-3 rounded mb-2 " style={{ backgroundColor: "#1A1A40" }}>
                    <img src={require(`../resource/testimonial-1.jpg`)} style={{ width: '100px', height: '100px', boxShadow: '0 0 0  5px purple' }} className="rounded-circle " alt="" />
                    <h4 className="my-2">Pratik Gandhi</h4>
                    <h6>Community Tutor</h6>
                    <div className="h6 white-3">Wed, Mar 30, 08:30  - 09:00</div>
                    <div className="p-2 mb-2 rounded border border-success">
                        <div className="d-flex justify-content-between">
                            <h6>Sub-total</h6>
                            <b>INR 380.00</b>
                        </div>
                        <div className="d-flex justify-content-between">
                            <h6>Processing fee</h6>
                            <b>INR {processingFee}.00</b>
                        </div>
                        <hr />
                        <div className="d-flex justify-content-between">
                            <h6>Total</h6>
                            <b>INR {380+processingFee}.00</b>
                        </div>
                    </div>
                    <Link to="" className="btn btn-block btn-success" onClick={()=>setSuccess(true)}>Pay INR {380+processingFee}.00</Link>

                </div>
            </div>
        }
        </div>
    )
}

export default Payment
